"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseProvider = void 0;
var BaseProvider = /** @class */ (function () {
    function BaseProvider(provider, httpClient) {
        this.provider = provider;
        this.httpClient = httpClient;
    }
    BaseProvider.prototype.handleLogin = function (credentials) {
        var _a = this, provider = _a.provider, httpClient = _a.httpClient;
        this.validateCredentials(credentials);
        return httpClient.post('authenticate', __assign(__assign({}, credentials), { provider: provider }));
    };
    BaseProvider.prototype.formatErrorMessage = function (credentials, expected) {
        return "Invalid credentials: " + JSON.stringify(credentials, null, 4) + " expected: " + JSON.stringify(expected, null, 4);
    };
    return BaseProvider;
}());
exports.BaseProvider = BaseProvider;
